import { getAPIUrl } from '../utils';
import AxiosClient, { getLogOptions } from './axios.service';

export const getFilteringActions = ({ accountId, authToken }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.get({
    options: getLogOptions(authToken, getFilteringActions.name),
    url: `${baseUrl}/activities/actions`,
  });
};

export const getFilteringLocations = ({ accountId, authToken }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.get({
    options: getLogOptions(authToken, getFilteringLocations.name),
    url: `${baseUrl}/activities/locations`,
  });
};

export const getFilteringPerformers = ({ accountId, authToken }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.get({
    options: getLogOptions(authToken, getFilteringPerformers.name),
    url: `${baseUrl}/activities/performers`,
  });
};
